import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  min-height: 600px;
  display: flex;
  align-items: center;
  background: linear-gradient(
    90deg,
    rgba(223, 223, 223, 1) 0%,
    rgba(248, 248, 248, 1) 79%
  );
  padding: 0 15px;
  @media (max-width: 767.98px) {
    min-height: 470px;
  }
`;
const Wrapper = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 1080px;
  width: 100%;
`;

const Section = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 0.5fr;
  @media (max-width: 700px) {
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 30px 0;
  }
`;

const Product = styled.a`
  cursor: pointer;
  text-align: center;
  padding: 10px 50px 10px 10px;
  img {
    display: inline-block;
    max-width: 100%;
    width: auto;
    height: auto;
  }
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 700px) {
    align-items: center;
  }
  h2 {
    font-size: 42px;
    font-size: clamp(26px, 2.5vw, 38px);
    line-height: 1.2;
    font-weight: 700;
    font-family: 'Lato';
    color: ${COLORS.BLACK};
    margin: 0;
  }
  h5 {
    font-family: 'Lato';
    font-size: 150%;
    line-height: 1.3;
    font-weight: 500;
    font-size: 24px;
    margin: 0;
  }
  p {
    color: ${COLORS.BLACK};
    font-size: 18px;
    line-height: 1.6;
    font-weight: 400;
    margin: 0;
  }
  button {
    background-color: ${COLORS.BLACK};
    font-size: 13px;
    border-radius: 50px;
    padding: 12px;
    line-height: 1.5;
    color: ${COLORS.WHITE};
    margin-top: 20px;
    width: 260px;
    font-weight: 700;
    :hover {
      background-color: ${COLORS.BLACK};
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
  }
`;

export { Container, Wrapper, Section, Product, Description };
